import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { configure } from "mobx";
import { Suspense } from "react";
import { createRoot } from "react-dom/client";

import App from "./components/App";
import { GalleryError } from "./components/partials/GalleryError";

import "normalize.css";
import "./lib/_fonts/fonts.css";
import "./index.css";

// import i18n (needs to be bundled)
import "./i18n";

configure({
  useProxies: "never",
});

const domNode = document.getElementById("mv-web-gallery");
if (!domNode) {
  throw new Error("Could not find element with id 'mv-web-gallery'");
}

const root = createRoot(domNode);

(async () => {
  let config = null;

  try {
    const response = await fetch(
      process.env.REACT_APP_CONFIG_BASEURL + "/scripts/config.js"
    );
    config = eval(await response.text());
  } catch (err) {
    console.error(err);
    if (process.env.REACT_APP_DEV) {
      config = {
        /* Allows project to run in development since config is not served. */
      };
    } else {
      root.render(<GalleryError />);
    }
  }

  if (!config) {
    return;
  }

  root.render(
    <Suspense fallback={null}>
      <App config={config} />
    </Suspense>
  );
})();
